export default __webpack_public_path__ + "static/media/SignIn.63f110c0.jpg";